/**
 * @fileoverview Cell contents for the Select column (allowing row select)
 * @author Derek Seo (dseo@yext.com)
 */
// @ts-nocheck
goog.declareModuleId('yext.ui.components.table.tablebody.selectcell');

import {Checkbox} from '/ui/components/checkbox/checkbox';
import {Radio} from '/ui/components/radio/radio';
import * as BodyTypes from '/ui/components/table/body/types';
import {INTERNAL_COL_IDS} from '/ui/components/table/common';
import * as Types from '/ui/components/table/types';
import {classNames} from '/ui/lib/classnames';
import {yext} from '/ui/lib/msg';

import * as styles from '/ui/components/table/body/tablebody.module.scss';

/**
*
* @param {!Types.Row} dataRow
* @param {!BodyTypes.TableBodyProps} props
* @returns {React.ReactElement}
*/
export function selectCell(dataRow, {
  isSelected,
  isDisabled,
  onSelectRow,
  isLoading,
  isSingleSelect,
}) {
  const className = classNames(
    styles.cell,
    styles.selectCell,
    // {[styles.singleSelect]: isSingleSelect},
  );
  const rowSelected = !isLoading && isSelected(dataRow.id);
  const rowDisabled = isLoading || isDisabled && isDisabled(dataRow.id);
  const onChange = () => {
    if (isLoading) {
      return; // There should be no way to get here, but do nothing anyways.
    }
    onSelectRow(dataRow.id, rowSelected);
  };
  let selectInput;
  if (isSingleSelect) {
    selectInput = (
      <Radio
        disabled={rowDisabled}
        checked={rowSelected}
        onChange={onChange}
        value={dataRow.id}
        label={yext.msg('Select row')}
        hideLabel
      />
    );
  } else {
    selectInput = (
      <Checkbox
        disabled={rowDisabled}
        checked={rowSelected}
        onChange={onChange}
        label={rowSelected ? yext.msg('Unselect row') : yext.msg('Select row')}
        hideLabel
        noMargin
      />
    );
  }
  return (
    <td className={className} key={INTERNAL_COL_IDS.SELECT}>
      {selectInput}
    </td>
  );
}
